import { defaultParamsSerializer, formatDates, handleApiResponse } from '@/functions';
import { useQuery } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IGetAuditLogsParams, IGetAuditLogsResponse } from '@/interfaces';

export const useRequestGetAuditLogs = (params?: IGetAuditLogsParams) => {
	const { invalidate } = useInvalidateQueries();
	const { isFetching, data, error } = useQuery({
		queryKey: [routes.api.auditLogs, params],
		queryFn: ({ queryKey: [_url, _params] }) =>
			apiClient
				.get<IGetAuditLogsResponse>(_url as string, _params as IGetAuditLogsParams, { paramsSerializer: defaultParamsSerializer })
				.then(handleApiResponse)
				.then(data => formatDates(data) as unknown as IGetAuditLogsResponse)
	});

	const auditLogs = data?.data ?? [];
	const refresh = () => invalidate(routes.api.auditLogs);

	return {
		data: data as IGetAuditLogsResponse,
		isLoading: isFetching,
		auditLogs,
		refresh,
		error
	};
};
